import React from "react";

interface Step {
  number: number;
  label: string;
  completed?: boolean;
  current?: boolean;
}

interface StepIndicatorProps {
  steps: Step[];
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ steps }) => {
  return (
    <div className="flex items-center space-x-4 mb-8">
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div className="flex items-center">
            <div
              className={`flex items-center justify-center size-8 rounded-full font-semibold text-sm z-10 ${
                step.current
                  ? "bg-[#2f4941] text-white"
                  : step.completed
                  ? "bg-[#2f4941] text-white"
                  : "bg-white border-2 border-gray-300 text-gray-400"
              }`}
            >
              {step.completed ? (
                <svg
                  className="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={3}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              ) : (
                step.number
              )}
            </div>
            <span
              className={`ml-2 text-sm font-medium ${
                step.current
                  ? "text-[#2f4941]"
                  : step.completed
                  ? "text-gray-800"
                  : "text-gray-400"
              }`}
            >
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`h-0.5 w-16 ${
                step.completed ? "bg-[#2f4941]" : "bg-surface-ui"
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepIndicator;

